// extracted by mini-css-extract-plugin
export default {"trialBanner":"TrialCountdownBanner_trialBanner__lttXo","clockIcon":"TrialCountdownBanner_clockIcon__aa3mV","ctaLink":"TrialCountdownBanner_ctaLink__0vq5G"};